import React from 'react';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers';

export const FormikDatePicker = ({
  form: { setFieldValue, handleBlur, errors, touched, setFieldTouched, setFieldError, validateField },
  field: { name, value },
  label,
  maxDate,
  disabled,
}) => {
  
  const isValidDate = (d) => d instanceof Date;
  
  const hasError = Boolean(touched[name] && errors[name]);

  return (
    <DatePicker
      label={label}
      maxDate={maxDate}
      disabled={disabled}                       
      inputFormat="MM/dd/yyyy"
      value={ value ?? null }
      onChange={(newVal) => {
        if (newVal === null) {
          setFieldValue(name, null, false);
        }
        else if(isValidDate(newVal)) {
          setFieldValue(name, newVal, false);
        }
      }}
      onAccept={(val) => {
        setFieldTouched(name, true, false)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          id={name}
          name={name}
          onBlur={handleBlur}
          error={hasError}
          helperText={hasError ? errors[name] : ""}
          fullWidth
        />
      )}
    />
  );
};
